module.exports = __webpack_public_path__ + "static/media/info-icon-blue.3e30ec69.svg";